<template>
  <el-group-title title="分包机械设备清单" class="pcConcSubDevice">
    <template slot="groupTitle">
      <el-form
        :model="formpcConcSubDevice"
        label-width="100px"
        class="ccui-form"
        style="overflow:visible;"
      >
        <el-table
          :data="dataInfo"
          style="margin-bottom:20px;width:100%;"
          class="ccui-form-child-table"
          border
          max-height="99999"
        >
          <el-table-column
            :show-overflow-tooltip="true"
            label="序号"
            type="index"
            align="center"
            fixed
          />
          <el-table-column
            :show-overflow-tooltip="true"
            prop="machineCode"
            label="机械编码"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="machineName"
            label="机械名称"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="specifications"
            label="规格型号"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="placeOfOrigin"
            label="产地"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="productionDate"
            label="制造时间"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="rateOfWork"
            label="能力/功率"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="dateOfEntry"
            label="进场日期"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="remark"
            label="备注"
          >
          </el-table-column>
          <!-- <el-table-column
            :show-overflow-tooltip="true"
            prop="scaleNum"
            label="操作"
            align="center"
            width="100%"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="delTable(scope.$index, scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </el-form>
    </template>
  </el-group-title>
</template>

<script>
export default {
  name: "pcConcSubDevice",
  props: {
    dataInfo: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      tableData: [
        {
          id: "",
          tPcConcSubId: "",
          machineCode: "",
          machineName: "",
          specifications: "",
          placeOfOrigin: "",
          productionDate: "",
          rateOfWork: "",
          dateOfEntry: "",
          remark: ""
        }
      ],
      formpcConcSubDevice: {}
    };
  },
  watch: {
    dataInfo() {
      this.tableData = this.dataInfo;
    }
  }
};
</script>
